import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'parenting-style');

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.id === activeCategory);
  const filteredArticles = articles.filter((a) => a.category === activeCategory);

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${currentCategory?.name || '分类'} - 俄罗斯妈妈`,
          description: currentCategory?.description || '探索俄罗斯妈妈的真实生活与育儿理念',
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 md:pt-24">
          <div className="max-w-7xl mx-auto w-full px-4 md:px-6">
            {/* Breadcrumb */}
            <div className="mb-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: currentCategory?.name || '分类' },
                ]}
              />
            </div>

            {/* Header */}
            <div className="mb-10">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                {currentCategory?.name}
              </h1>
              <p className="text-sm text-foreground-500">{currentCategory?.description}</p>
            </div>

            {/* Category Tabs */}
            <div className="flex flex-wrap items-center gap-2 mb-10 border-b border-background-200/70 pb-4">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.id}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center inline-block mr-1.5">
                    <i className={`${cat.icon} text-xs`}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            {/* Articles Grid */}
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-14 md:pb-20">
                {filteredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-400">该分类暂无文章</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}